import { combineReducers } from "redux";
import { home } from "./home.reducer";
import { config } from "./config.reducer";
import { blog } from "./blogDetail.reducer";
import { european } from "./european.reducer";
import { finance } from "./finance.reducer";
import { contact } from "./contact.reducers";
import { HpiCheck } from "./HPICheck.reducer";
import { page } from "./page.reducer";
import { faq } from "./faqDetails.reducer";
import { sell } from "./sellCar.reducer";

const appReducers = combineReducers({
  home,
  config,
  blog,
  european,
  finance,
  contact,
  HpiCheck,
  page,
  faq,
  sell
});

const rootreducer = (state, action) => {
  return appReducers(state, action);
};

export default rootreducer;
